import firebase from 'firebase'
var config = {
  apiKey: "AIzaSyAQWY_cwxJzoUBCgiVfhHqIPx3hoH95OWo",
  authDomain: "border-landscaping.firebaseapp.com",
  databaseURL: "https://border-landscaping.firebaseio.com",
  projectId: "border-landscaping",
  storageBucket: "",
  messagingSenderId: "1044846547928"
};
var fire = firebase.initializeApp(config);
export default fire;



// WEBPACK FOOTER //
// ./src/fire.js